export default "__VITE_ASSET__CiXH6Tmx__"